import { ApiError } from '@/platform/lib/api';
import { TERMS_REQUIRED_MESSAGE } from './validate';

export function policyErrorMessage(err: unknown): string | null {
  if (!(err instanceof ApiError)) return null;
  if (err.code === 'terms_required') return TERMS_REQUIRED_MESSAGE;
  return null;
}
